module.exports = __webpack_public_path__ + "media/kick.5c998a5f.mp3";